import React from 'react'
import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'
import 'core-js/stable'
import 'regenerator-runtime/runtime'
import 'react-app-polyfill/ie11'

class Editor extends React.Component {
  render () {
    // ViewModeコンポーネントに、Rails View の 'react_component' タグで引き渡されたデータを渡す
    // （これらのデータは、それぞれのコンポーネントで 'props' 経由でアクセスできる）
    return(<ViewMode article={ this.props.article } member_name={ this.props.member_name } update_url={ this.props.update_url } csrf_token={ this.props.csrf_token }/>);
  }
}

class ViewMode extends React.Component {
  // コンストラクタ
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick() {
    ReactDOM.render(<EditMode article={ this.props.article } member_name={ this.props.member_name } update_url={ this.props.update_url } csrf_token={ this.props.csrf_token }/>, document.getElementById('editor_area'));
  }

  render () {
    return (
      <React.Fragment>
        <button id="button_edit" onClick={ this.handleClick }>編集する</button>
        <div className="fields">
          <div className="field"><span className="label">投稿日　：</span><span className="value">{ this.props.article.contributed_at }</span></div>
          <div className="field"><span className="label">投稿者　：</span><span className="value">{ this.props.member_name            }</span></div>
          <div className="field"><span className="label">タイトル：</span><span className="value">{ this.props.article.title          }</span></div>
          <div className="field"><span className="label">投稿内容：</span><span className="value">{ this.props.article.body           }</span></div>
        </div>
      </React.Fragment>
    );
  }
}

class EditMode extends React.Component {
  // コンストラクタ
  constructor(props) {
    super(props);
    this.state = { article: this.props.article };
    this.handleClick = this.handleClick.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  handleClick() {
    // articleの更新
    fetch(this.props.update_url, {
      method: 'PUT',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': this.props.csrf_token
      },
      body: JSON.stringify({
        article: { title: this.state.article.title, body: this.state.article.body },
        authenticity_token: this.props.csrf_token
      })
    }).then((response) => {
      if (response.status >= 200 && response.status < 300) {
        return response.json();
      } else {
        const error = new Error(response.statusText);
        throw error;
      }
    });
    // ViewModeを再表示
    ReactDOM.render(<ViewMode article={ this.state.article } member_name={ this.props.member_name } update_url={ this.props.update_url } csrf_token={ this.props.csrf_token }/>, document.getElementById('editor_area'));
  }

  handleChange(e) {
    var article = this.state.article;
    switch (e.target.id) {
    case 'title':
      article.title = e.target.value;
      break;
    case 'body':
      article.body = e.target.value;
    }
    // 状態を更新
    this.setState({ article: article });
  }

  render () {
    return (
      <React.Fragment>
        <button id="button_update" onClick={ this.handleClick }>更新する</button>
        <div className="fields">
          <div className="field"><span className="label">投稿日　：</span><span className="value">{ this.props.article.contributed_at }</span></div>
          <div className="field"><span className="label">投稿者　：</span><span className="value">{ this.props.member_name            }</span></div>
          <div className="field"><span className="label">タイトル：</span><span className="value"><input type="text" id="title" value={ this.state.article.title } onChange={ this.handleChange }/></span></div>
          <div className="field"><span className="label">投稿内容：</span><span className="value"><textarea id="body" rows="10" cols="60" onChange={ this.handleChange } value={ this.state.article.body }/></span></div>
        </div>
      </React.Fragment>
    );
  }
}

Editor.propTypes = { article: PropTypes.object }

export default Editor
